import * as yup from 'yup'
import { VALIDATION_PATTERNS } from '../../config'

export const mediaTypeValidationSchema = yup.object({
  title: yup
    .string()
    .trim()
    .max(50, 'The text is too long, maximum number of characters is 50')
    .required('This is a required field.'),
  mediaContentType: yup
    .string()
    .trim()
    .max(50, 'The text is too long, maximum number of characters is 50')
    .required('This is a required field.'),
  extension: yup
    .string()
    .matches(
      VALIDATION_PATTERNS.EXTENSION_START,
      'Extension should start with a dot.'
    )
    .matches(
      VALIDATION_PATTERNS.EXTENSION,
      "Only the following characters are allowed: A-Z 0-9 $#&+@!()-{}'`_~, and the space."
    )
    .max(255, 'The text is too long, maximum number of characters is 255')
    .required('This is a required field.'),
  mimeType: yup
    .string()
    .max(255, 'The text is too long, maximum number of characters is 255')
    .matches(
      VALIDATION_PATTERNS.VALID_MIME_TYPE_CHARACTERS,
      'The text contains invalid characters.'
    )
    .matches(
      VALIDATION_PATTERNS.MIME_TYPE,
      'Mime type should have the following format: word1/word2.'
    )
    .required('This is a required field.'),
})
